import { z } from "zod";
import {
  optionalBooleanFromString,
  optionalStringArray,
  trimmedString,
} from "./primitives";
import { assigneeTypeSchema } from "./assignments";
import { entityPrioritySchema } from "./entities";

export const triageStatusSchema = z.enum([
  "new",
  "triage",
  "in_progress",
  "resolved",
]);

export const triageOwnerSchema = z.object({
  type: assigneeTypeSchema,
  id: trimmedString,
});

export const createTriageRuleSchema = z.object({
  name: trimmedString,
  keywords: optionalStringArray.default([]),
  enabled: optionalBooleanFromString.default(true),
  status: triageStatusSchema.optional(),
  priority: entityPrioritySchema.optional(),
  triageOwner: triageOwnerSchema.optional(),
});

export const updateTriageRuleSchema = z.object({
  name: trimmedString.optional(),
  keywords: optionalStringArray.optional(),
  enabled: optionalBooleanFromString.optional(),
  status: triageStatusSchema.optional(),
  priority: entityPrioritySchema.optional(),
  triageOwner: z.union([triageOwnerSchema, z.null()]).optional(),
});

export type CreateTriageRulePayload = z.infer<typeof createTriageRuleSchema>;
export type UpdateTriageRulePayload = z.infer<typeof updateTriageRuleSchema>;
